import Cookies from 'js-cookie';
import type { ConsentStatus } from './types';

export const CONSENT_COOKIE_NAME = 'first-table-cookie-consent';

const EXPIRES_DAYS = 365;

export const removeConsentCookie = (): void => {
  Cookies.remove(CONSENT_COOKIE_NAME);
};

export const readConsentCookie = (): ConsentStatus => {
  const value = Cookies.get(CONSENT_COOKIE_NAME);

  if (value === 'accepted') return 'accepted';
  if (value === 'rejected') return 'rejected';
  return 'undecided';
};

/**
 * Server-side counterpart to readConsentCookie: parses the consent decision out of a raw
 * `Cookie` request header. Used where the decision must be known before the client hydrates —
 * e.g. gating the GTM `<noscript>` iframe in `_document.tsx` for no-JS users.
 */
export const readConsentFromCookieHeader = (cookieHeader?: string): ConsentStatus => {
  if (!cookieHeader) return 'undecided';

  const match = cookieHeader
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${CONSENT_COOKIE_NAME}=`));

  if (!match) return 'undecided';

  const value = match.slice(CONSENT_COOKIE_NAME.length + 1);
  if (value === 'accepted') return 'accepted';
  if (value === 'rejected') return 'rejected';
  return 'undecided';
};

export const writeConsentCookie = (status: ConsentStatus): void => {
  if (status === 'undecided') {
    removeConsentCookie();
    return;
  }

  Cookies.set(CONSENT_COOKIE_NAME, status, { expires: EXPIRES_DAYS });
};
